import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/invitefree'
    },
    {
      path: '/invitefree',
      component: require('@/page/InviteUser').default,
      meta: {title: '免费领取会员'}
    },
    {
      path: '/vip',
      name: 'Vip',
      component: require('@/page/Vip').default,
      meta: {title: '免费领取会员'}
    },
    {
      path: '/success',
      name: 'Success',
      component: require('@/page/Success').default,
      meta: {title: '免费领取会员'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js